import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
import { AppStore } from '../app.store'
import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, first, firstValueFrom, from, of, switchMap } from 'rxjs'
import { MeService } from '../services/me/me.service'

export const integratedAccountsGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const router = inject(Router)
    const preferredAccountsSystemId = inject(AppStore).me()?.preferredAccountsSystemId
    let loggedIn = false
    let hasAccess = false
    const appStore = inject(AppStore)

    if (appStore.me()) {
        const me = appStore.me()
        const preferredAccountsSystemId = me?.preferredAccountsSystemId
        loggedIn = me?.loggedIntoAccounts ?? false
        hasAccess = !!loggedIn && !!preferredAccountsSystemId && preferredAccountsSystemId > 0

        return hasAccess
    }

    hasAccess = await firstValueFrom(inject(MeService).getMe())
        .then((me) => {
            const preferredAccountsSystemId = me?.preferredAccountsSystemId
            loggedIn = me?.loggedIntoAccounts
            hasAccess = !!loggedIn && !!preferredAccountsSystemId && preferredAccountsSystemId > 0

            return hasAccess
        })
        .catch((error) => {
            return false
        })

    if (hasAccess) {
        return true
    }

    return router.navigateByUrl('/accounts-integrations/selector')
}
